import { createFileRoute } from '@tanstack/react-router'
import MaintenancePageClient from '#/components/maintenance/MaintenancePageClient'
import { useFeatureFlags } from '#/lib/queries/index'
import { FeatureDisabledNotice } from '#/components/FeatureDisabledNotice'

function MaintenanceRoute() {
  const { maintenanceEnabled, isLoading } = useFeatureFlags()
  if (isLoading) return null
  if (!maintenanceEnabled) return <FeatureDisabledNotice feature="Maintenance" />
  return <MaintenancePageClient />
}

export const Route = createFileRoute('/_authenticated/$slug/maintenance')({
  component: MaintenanceRoute,
})
